function ListIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33.21 26.58" {...props}>
      <path d="M3,16.29a2.93,2.93,0,0,1-2.13-.87,3,3,0,0,1,0-4.25A2.94,2.94,0,0,1,3,10.29a2.9,2.9,0,0,1,2.13.88,3,3,0,0,1,0,4.25A3,3,0,0,1,3,16.29ZM3,6A2.91,2.91,0,0,1,.87,5.15,3,3,0,0,1,0,3,2.89,2.89,0,0,1,.87.88,2.9,2.9,0,0,1,3,0,3,3,0,0,1,5.15.88,2.87,2.87,0,0,1,6,3a3,3,0,0,1-.89,2.17A3,3,0,0,1,3,6ZM3,26.58a2.93,2.93,0,0,1-2.13-.87A2.9,2.9,0,0,1,0,23.58a3,3,0,0,1,.87-2.14A2.92,2.92,0,0,1,3,20.54a2.88,2.88,0,0,1,2.13.9A3,3,0,0,1,6,23.62a2.84,2.84,0,0,1-.87,2.11A3,3,0,0,1,3,26.58Zm6.92-.83V21.38H33.21v4.37Zm0-10.29V11.12H33.21v4.34Zm0-10.25V.83H33.21V5.21Z" />
    </svg>
  );
}

export default ListIcon;
